import React from 'react';
import '../css/main.css';
import PageBannerImage from '../Images/ISC-PropEx-BG-Image.jpg';
import PropertyImage from "../Images/ISC-PropEx-HouseImage.png";
import SalesPurchaseImage from "../Images/ISC-PropEx-Sale&Purchase.png";
import PropertyScreeningImage from "../Images/ISC-PropEx-PropertyScreening.png";

const Pagebanner = () => {
    return (
        <div className="jumbotron carousel slide" id="carouselExampleControls" data-bs-ride="carousel" style={{backgroundImage:`url(${PageBannerImage})`,backgroundSize:"cover"}}>
                <ol className="carousel-indicators">
                        <li data-target="#carouselExampleControls" data-slide-to="0" className="active"></li>
                        <li data-target="#carouselExampleControls" data-slide-to="1"></li>
                        <li data-target="#carouselExampleControls" data-slide-to="2"></li>
                    </ol>
                <div className="container">
                   
                   
                        <div className="carousel-inner">
                            <div className="carousel-item active" data-bs-interval="10000">
                                <div className="row">
                                    <div className="col-md-7 col-lg-7">
                                        <h4 className="banner-title">Looking to <span>EXCHANGE</span> your <br/>
                                            Old Property and get New Property</h4>
                                            <p>They say you should never let a crisis go to waste. During Corona, there was a crisis in real estate,  and there was an imbalance created in the Real Estate industry. The imbalance of a difference of growth in Commercial realty vs Residential Realty. The biggest factor was uncertainty. We at ISC believe that the "REAL ESTATE" will never go unreal so truly to the value of the land or built-up space, we decided to start offering PROPERTY EXCHANGE. Now you can exchange your property to buy a new property instead of arranging for finances. And that too in a legal structure. Welcome to our new idea and click below to explore our properties available under exchange.</p>
                                            <a class="btn btn-primary btn-lg" href="#propertyExchange" role="button">EXCHANGE NOW</a>
                                        
                                    </div>
                                    <div className="col-md-5 col-lg-5">
                                        <img src={PropertyImage} alt="PropertyImage" style={{width:"100%"}} />
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item" data-bs-interval="2000">
                                <div className="row">
                                    <div className="col-md-7 col-lg-7">
                                        <h4 className="banner-title">Looking for <span>LEGAL AND VALUATIONS SERVICES</span> for your new or old property ?</h4>
                                            <p>ISC Realty has a team of lawyers and valuation agents and we take pride in our 20 year old history of real estate management.</p>
                                            <p>ISC is now giving property valuation, property screening and legal services for property as a paid service.</p>
                                            <a class="btn btn-primary btn-lg" href={`${process.env.PUBLIC_URL}/property-screening`} role="button">Call us to know more.</a>
                                        
                                    </div>
                                    <div className="col-md-5 col-lg-5">
                                        <img src={SalesPurchaseImage} alt="PropertyImage" style={{width:"100%"}} />
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item" data-bs-interval="3000">
                                <div className="row">
                                    <div className="col-md-7 col-lg-7">
                                        <h4 className="banner-title">Do you want to  <span>buy or sell a property</span> using ISC Realty ?</h4>
                                            <p>ISC Realty is one of the top channel partners for many real estate companies and we also deal with individual properties, commercial and residential, land or built up spaces.</p>
                                            <p>Contact our agents to list your property here for sales related queries. We only list mandated properties to us.</p>
                                            <a class="btn btn-primary btn-lg" href="#propertyExchange" role="button">Know More</a>
                                        
                                    </div>
                                    <div className="col-md-5 col-lg-5">
                                        <img src={PropertyScreeningImage} alt="PropertyImage" style={{width:"100%"}} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                
                </div>
           

       
    )
};
export default Pagebanner;